// extracted by mini-css-extract-plugin
export default {"currencySelect":"PriceRangeFilter_currencySelect__bM7qH","priceInputs":"PriceRangeFilter_priceInputs__zQZJO","setPriceButton":"PriceRangeFilter_setPriceButton__9GS95"};